import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "finances" }
const _hoisted_2 = {
  key: 0,
  class: "stats"
}
const _hoisted_3 = { class: "stat" }
const _hoisted_4 = { class: "title ellipsis" }
const _hoisted_5 = { class: "value ellipsis" }
const _hoisted_6 = { class: "note ellipsis" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Segment = _resolveComponent("Segment")
  const _component_CollapseMenu = _resolveComponent("CollapseMenu")

  return (_openBlock(), _createBlock(_component_CollapseMenu, {
    loading: $options.loading,
    class: "collapse-menu",
    title: $options.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($options.stats)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stats, (stat) => {
                return (_openBlock(), _createBlock(_component_Segment, {
                  key: stat.title,
                  flat: "",
                  class: "stat-segment"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(stat.title), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(stat.value), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(stat.note), 1 /* TEXT */)
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($options.info)
          ? (_openBlock(), _createBlock(_component_Segment, {
              key: 1,
              class: "info",
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode($setup["MdContent"], { markdown: $options.info }, null, 8 /* PROPS */, ["markdown"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["loading", "title"]))
}